module.exports = __webpack_public_path__ + "img/icon-parent.01bb203.png";